import { render, staticRenderFns } from "./ShipayPaymentModal.vue?vue&type=template&id=55096938&"
import script from "./ShipayPaymentModal.vue?vue&type=script&lang=js&"
export * from "./ShipayPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./ShipayPaymentModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports